import React, { Component } from 'react'
import PlusIcon from '../../icons/plusicon';
import { Link } from 'react-router-dom';
// import Slider from "react-slick";

import TextField from './../../component/TextField';
// Editors
import TextEditor from '../../component/TextEditor';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import DropdownMaster from '../../component/DropdownMaster';
import Select from 'react-select';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../redux/bindActionCretor';
import service from '../../services';

//Validation import 
import SimpleReactValidator from 'simple-react-validator';
import Loader from '../../component/loader';
import PopUpCustomAll from '../../component/fpg/create/popUpCustomAll';
import moment from 'moment';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import ImageOnlyUpload from '../ImageOnlyUpload';
import commonImage from '../../commonImage';
import DeletefileIcon from '../../icons/DeletefileIcon';
import AddFileIcon from '../../icons/plusicon';
import ErrorPopUp from '../../component/errorPopUp';
import CopyIcon from '../../icons/copyicon';
import Slider from 'react-slick';
import UploadForm from '../../component/fpg/create/UploadForm';
import { STORAGE_PATHS } from '../../cosntants';
import RecordPresenceBanner from '../../component/RecordPresenceBanner';
import ConflictSaveModal from '../../component/ConflictSaveModal';

const mapStateToProps = state => ({
    locationEditId: state.locationEditId,
    recordViewers: state.recordViewers,
    recordConflict: state.recordConflict,
    getLoginAdminByID: state.getLoginAdminByID,
    allInitial: state.allInitial,
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};

let sub;
class CreateLocations extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loaderFlag: false,
            discardPopup: false,
            editStartVersion: null,
            Ophours: EditorState.createEmpty(),
            Avbusroutes: EditorState.createEmpty(),
            LocDesc: EditorState.createEmpty(),
            acessDesc: EditorState.createEmpty(),
            amenitiesFeatures: EditorState.createEmpty(),
            dailyOffer: EditorState.createEmpty(),
            locationId: this.props.locationEditId,
            locationname: "",
            street: "",
            operatingHrs: "",
            avaliableBusRoutes: "",
            venueType: "",
            selectedVenue: "",
            description: "",
            accessibility: [],
            selectedAccessibility: [],
            city: "",
            zip: "",
            state: "",
            latitude: "",
            longitude: "",
            google_map_link: "",
            satellite_screen_link: "",
            daily_offerings: '',
            amenity: [],
            selectedAmenity: [],
            logo: {
                inSite: "",
            },
            hostName: "",
            imagePreloader: false,
            deleteImagePopup: false,
            errorPopup: false,
            hide_from_schedule: false,
            stateoption: [
                { value: "Alaska", name: "Alaska" },
                { value: "Alabama", name: "Alabama" },
                { value: "Arkansas", name: "Arkansas" },
                { value: "American Samoa", name: "American Samoa" },
                { value: "Arizona", name: "Arizona" },
                { value: "California", name: "California" },
                { value: "Colorado", name: "Colorado" },
                { value: "Connecticut", name: "Connecticut" },
                { value: "District of Columbia", name: "District of Columbia" },
                { value: "Delaware", name: "Delaware" },
                { value: "Florida", name: "Florida" },
                { value: "Georgia", name: "Georgia" },
                { value: "Guam", name: "Guam" },
                { value: "Hawaii", name: "Hawaii" },
                { value: "Iowa", name: "Iowa" },
                { value: "Idaho", name: "Idaho" },
                { value: "Illinois", name: "Illinois" },
                { value: "Indiana", name: "Indiana" },
                { value: "Kansas", name: "Kansas" },
                { value: "Kentucky", name: "Kentucky" },
                { value: "Louisiana", name: "Louisiana" },
                { value: "Massachusetts", name: "Massachusetts" },
                { value: "Maryland", name: "Maryland" },
                { value: "Maine", name: "Maine" },
                { value: "Michigan", name: "Michigan" },
                { value: "Minnesota", name: "Minnesota" },
                { value: "Missouri", name: "Missouri" },
                { value: "Mississippi", name: "Mississippi" },
                { value: "Montana", name: "Montana" },
                { value: "North Carolina", name: "North Carolina" },
                { value: "North Dakota", name: "North Dakota" },
                { value: "Nebraska", name: "Nebraska" },
                { value: "New Hampshire", name: "New Hampshire" },
                { value: "New Jersey", name: "New Jersey" },
                { value: "New Mexico", name: "New Mexico" },
                { value: "Nevada", name: "Nevada" },
                { value: "New York", name: "New York" },
                { value: "Ohio", name: "Ohio" },
                { value: "Oklahoma", name: "Oklahoma" },
                { value: "Oregon", name: "Oregon" },
                { value: "Pennsylvania", name: "Pennsylvania" },
                { value: "Puerto Rico", name: "Puerto Rico" },
                { value: "Rhode Island", name: "Rhode Island" },
                { value: "South Carolina", name: "South Carolina" },
                { value: "South Dakota", name: "South Dakota" },
                { value: "Tennessee", name: "Tennessee" },
                { value: "Texas", name: "Texas" },
                { value: "Utah", name: "Utah" },
                { value: "Virginia", name: "Virginia" },
                { value: "Virgin Islands", name: "Virgin Islands" },
                { value: "Vermont", name: "Vermont" },
                { value: "Washington", name: "Washington" },
                { value: "Wisconsin", name: "Wisconsin" },
                { value: "West Virginia", name: "West Virginia" },
                { value: "Wyoming", name: "Wyoming" }
            ],
            getLastUpdated: "",
            lastUpdatedBy: "",
            lastUpdatedAt: "",
            images:[
                {
                    _id:Math.random(),
                    link: "",
                    inSite: ""
                },
                {
                    _id:Math.random(),
                    link: "",
                    inSite: ""
                },
                {
                    _id:Math.random(),
                    link: "",
                    inSite: ""
                }
            ],
            maxWaitListSlots:0,
            waitListSlotValid:'',
            iscreateLocationsEdited: false,
            showConflictModal: false,
        }
        this._hasLeftPresence = false;
        this.apiserve = new service();
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            validators: {
                Locname: {  // name the rule
                    message: 'The Location Name field is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                Locaddress: {  // name the rule
                    message: 'The Street Address field is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                City: {  // name the rule
                    message: 'The City field is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                VenueType: {  // name the rule
                    message: 'The Venue Type field is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                State: {
                    message: 'The State field is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true
                },
                Zip: {
                    message: 'The Zip Code field is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[0-9a-zA-Z -]+$/ig) && params.indexOf(val) === -1
                    },
                    required: true
                },
                urlValidation: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                }
            }
        })
    }

    getCurrentFormData = () => {
        const normalizeDraftHtml = (editorState) => {
            if (!editorState || typeof editorState === 'string') return '';
            const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
            return (html === '<p></p>\n' || html === '<p></p>') ? '' : html;
        };

        return cloneDeep({
            eventiveId: this.state.eventiveId,
            name: this.state.locationname,
            street: this.state.street,
            city: this.state.city ? this.state.city.value : "",
            state: this.state.state ? this.state.state.value : "",
            zip: this.state.zip,
            operatingHrs: normalizeDraftHtml(this.state.Ophours),
            avaliableBusRoutes: normalizeDraftHtml(this.state.Avbusroutes),
            venueType: this.state.selectedVenue ? this.state.selectedVenue.value : "",
            description: normalizeDraftHtml(this.state.LocDesc),
            eventive_description: this.state.LocDesc ? convertToRaw(this.state.LocDesc.getCurrentContent()).blocks.map(item => item.text).join('') : "",
            accessibility: this.state.selectedAccessibility ? this.state.selectedAccessibility.map(e => e.value) : [],
            accessibilityDescription: normalizeDraftHtml(this.state.acessDesc),
            latitude: this.state.latitude,
            longitude: this.state.longitude,
            google_map_link: this.state.google_map_link,
            satellite_screen_link: this.state.satellite_screen_link,
            amenity: this.state.selectedAmenity ? this.state.selectedAmenity.map(e => e.value) : [],
            amenitiesFeatures: normalizeDraftHtml(this.state.amenitiesFeatures),
            daily_offerings: normalizeDraftHtml(this.state.dailyOffer),
            logo: this.state.logo,
            hostName: this.state.hostName,
            images: this.state.images,
            hideFromSchedule: this.state.hide_from_schedule,
            maxWaitListSlots: this.state.maxWaitListSlots || 0,
        });
    }

    markcreateLocationsEdited = () => {
        if (this.state.initialData) {
            const isDirty = !isEqual(this.state.initialData, this.getCurrentFormData());
            if (this.state.iscreateLocationsEdited !== isDirty) {
                this.setState({ iscreateLocationsEdited: isDirty });
            }
        }
    }

    updateState = (state, callback) => {
        this.setState(state, () => {
            this.markcreateLocationsEdited();
            if (callback) callback();
        });
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
        window.removeEventListener('beforeunload', this._handleBeforeUnload);
        if (!this._hasLeftPresence && this.props.locationEditId) {
            this.apiserve.sendevent('RecordPresence|leave', {
                modelName: 'location',
                recordId: this.props.locationEditId
            });
            this._hasLeftPresence = true;
        }
        this.props.ClearRecordPresence();
    }

    AccessibilityChange = (selectedOptions) => {
        this.updateState({
            selectedAccessibility:selectedOptions === null? []:selectedOptions
        });
    }
    AmenityChange = (selectedOptions) => {
        this.updateState({
            selectedAmenity:selectedOptions=== null? []:selectedOptions
        });
    }

    _handleBeforeUnload = (e) => {
        if (this._hasLeftPresence || !this.props.locationEditId) return;
        this.apiserve.sendevent('RecordPresence|leave', {
            modelName: 'location',
            recordId: this.props.locationEditId
        });
        this._hasLeftPresence = true;
    };

    componentDidMount() {
        this.props.ClearRecordPresence();
        if (this.props.allInitial && this.props.allInitial.location) {
            this.setState({
                accessibility: this.props.allInitial.location.accessibility,
                venueType: this.props.allInitial.location.venueType,
                amenity: this.props.allInitial.location.amenity,
                cityoption: this.props.allInitial.location.city
            })
        }
        if (this.state.locationId) {
            this.apiserve.sendevent("location|getAllDetail", { locationId: this.props.locationEditId });
        } else {
            this.setState({ initialData: this.getCurrentFormData(), iscreateLocationsEdited: false });
        }

        // RecordPresence setup - only for edit mode
        if (this.props.locationEditId) {
            this.apiserve.sendevent('RecordPresence|join', {
                modelName: 'location',
                recordId: this.props.locationEditId
            });
            window.addEventListener('beforeunload', this._handleBeforeUnload);
        }

        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "RecordPresence|viewersUpdate":
                    if (response?.data?.recordId === this.props.locationEditId) {
                        const currentUserId = this.props.getLoginAdminByID;
                        const viewers = response?.data?.viewers || [];
                        const currentUserSessionCount = viewers.filter(v => v?.userId === currentUserId).length;
                        const currentUserHasMultipleSessions = currentUserSessionCount > 1;
                        const seenIds = new Set();
                        const filteredViewers = viewers
                            .filter(v => {
                                if (v?.userId === currentUserId) {
                                    return currentUserHasMultipleSessions;
                                }
                                return true;
                            })
                            .filter(v => {
                                if (seenIds.has(v?.userId)) return false;
                                seenIds.add(v?.userId);
                                return true;
                            })
                            .map(v => ({
                                userId: v?.userId,
                                userName: `${v?.fname || ''} ${v?.lname || ''}`.trim() || 'Unknown User'
                            }));
                        this.props.SetRecordViewers(filteredViewers);
                    }
                    break;
                case "RecordPresence|recordUpdated":
                    if (response?.data?.recordId === this.props.locationEditId && response?.data?.updatedBy?._id !== this.props.getLoginAdminByID) {
                        const updatedBy = response?.data?.updatedBy;
                        this.props.SetRecordConflict({
                            userName: updatedBy ? `${updatedBy?.fname || ''} ${updatedBy?.lname || ''}`.trim() : 'another user',
                            updatedAt: response?.data?.updatedAt
                        });
                    }
                    break;
                case "RecordPresence|join":
                    if (!response.error && response?.data?.recordUpdatedAt) {
                        this.setState({ editStartVersion: response.data.recordUpdatedAt });
                    }
                    break;
                case "location|create":
                    if (!response.error) {
                        this.clearData();
                        this.setState({ loaderFlag: false })
                        this.apiserve.success('Created successfully.')
                        this.props.history.push('/locations')

                    }
                    else {
                        this.setState({ errorPopup: true, errorMsg: response.data.error ? response.data.error : response.data })
                    }
                    break;
                case "location|edit":
                    if (!response.error) {
                        this.clearData();
                        this.setState({ loaderFlag: false })
                        this.apiserve.success('Updated successfully.')
                        this.apiserve.sendevent("location|getAllDetail", { locationId: response.data._id });
                    } else if (response.data?.error === 'CONFLICT_DETECTED') {
                        this.props.SetRecordConflict({
                            userName: 'another user',
                            updatedAt: response.data?.data?.currentUpdatedAt
                        });
                        this.setState({ showConflictModal: true, loaderFlag: false });
                    } else {
                        this.setState({ errorPopup: true, errorMsg: response.data.error ? response.data.error : response.data })
                    }
                    break;
                case "location|getAllDetail":
                    if (!response.error) {
                        var accessibilityData = response ?.data ?.accessibility.map(item => {
                            var accessibility = { value: item._id, label: item.name }
                            return accessibility
                        })

                        var amenityData = response ?.data ?.amenity.map(item => {
                            var amenity = { value: item._id, label: item.name }
                            return amenity
                        })

                        var images = response.data && response.data.images && response.data.images.map((image) => {
                            var imageData = {
                                _id: Math.random(),
                                inSite: image.inSite,
                                link: image.link
                            }
                            return imageData
                        })

                        if (response ?.data) {
                            if (response?.data?.updatedAt) {
                                this.setState({ editStartVersion: response.data.updatedAt });
                            }
                            const DATA = response.data;
                            let Ophours = this.state.Ophours;
                            if (DATA?.operatingHrs) {
                                const blocksFromHtml = htmlToDraft(DATA.operatingHrs);
                                Ophours = EditorState.createWithContent(ContentState.createFromBlockArray(blocksFromHtml.contentBlocks, blocksFromHtml.entityMap));
                            }
                            let Avbusroutes = this.state.Avbusroutes;
                            if (DATA?.avaliableBusRoutes) {
                                const blocksFromHtml = htmlToDraft(DATA.avaliableBusRoutes);
                                Avbusroutes = EditorState.createWithContent(ContentState.createFromBlockArray(blocksFromHtml.contentBlocks, blocksFromHtml.entityMap));
                            }
                            let LocDesc = this.state.LocDesc;
                            if (DATA?.description) {
                                const blocksFromHtml = htmlToDraft(DATA.description);
                                LocDesc = EditorState.createWithContent(ContentState.createFromBlockArray(blocksFromHtml.contentBlocks, blocksFromHtml.entityMap));
                            }
                            let dailyOffer = this.state.dailyOffer;
                            if (DATA?.daily_offerings) {
                                const blocksFromHtml = htmlToDraft(DATA.daily_offerings);
                                dailyOffer = EditorState.createWithContent(ContentState.createFromBlockArray(blocksFromHtml.contentBlocks, blocksFromHtml.entityMap));
                            }
                            let acessDesc = this.state.acessDesc;
                            if (DATA?.accessibilityDescription) {
                                const blocksFromHtml = htmlToDraft(DATA.accessibilityDescription);
                                acessDesc = EditorState.createWithContent(ContentState.createFromBlockArray(blocksFromHtml.contentBlocks, blocksFromHtml.entityMap));
                            }
                            let amenitiesFeatures = this.state.amenitiesFeatures;
                            if (DATA?.amenitiesFeatures) {
                                const blocksFromHtml = htmlToDraft(DATA.amenitiesFeatures);
                                amenitiesFeatures = EditorState.createWithContent(ContentState.createFromBlockArray(blocksFromHtml.contentBlocks, blocksFromHtml.entityMap));
                            }

                            this.setState({
                                eventiveId:DATA.eventiveId,
                                city: {value:DATA.city?._id},
                                zip: DATA.zip,
                                state: { value: DATA.state },
                                locationname: DATA.name,
                                street: DATA.street,
                                operatingHrs: DATA.operatingHrs,
                                avaliableBusRoutes: DATA.avaliableBusRoutes,
                                selectedVenue: { value: DATA.venueType ?._id, label: DATA.venueType ?.name},
                                description: DATA.description,
                                selectedAccessibility: accessibilityData,
                                latitude: DATA.latitude,
                                longitude: DATA.longitude,
                                google_map_link: DATA.google_map_link,
                                satellite_screen_link: DATA.satellite_screen_link,
                                selectedAmenity: amenityData,
                                daily_offerings: DATA.daily_offerings,
                                Ophours,
                                Avbusroutes,
                                LocDesc,
                                dailyOffer,
                                acessDesc,
                                amenitiesFeatures,
                                logo: DATA.logo,
                                hostName: DATA.hostName,
                                hide_from_schedule: DATA.hideFromSchedule,
                                images:images.length > 0 ? images : this.state.images,
                                maxWaitListSlots: DATA?.maxWaitListSlots ? DATA?.maxWaitListSlots : 0,
                                getLastUpdated: response?.data,
                                lastUpdatedBy: response?.data?.updatedBy,
                                lastUpdatedAt: response?.data?.updatedAt,
                                iscreateLocationsEdited: false,
                            }, () => {
                                this.setState({ initialData: this.getCurrentFormData(), iscreateLocationsEdited: false });
                            })
                        }
                    }
                    else {
                        this.setState({ errorPopup: true, errorMsg: response.data.error ? response.data.error : response.data })
                    }
                    break;
            }
        })
    }
    setEditorValue = (value, field) => {
        const blocksFromHtml = htmlToDraft(value);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        const data = EditorState.createWithContent(contentState);
        this.setState({
            [field]: data
        })
    }

    onInputChange = (e) => {
        if(e.target.name === "maxWaitListSlots"){
            let waitListSlotValid = ''
            if(e.target.value.length > 3){
                waitListSlotValid = 'Value cannot exceed 3 characters.'
            } else if(/[a-zA-Z!@#$%^&*()_+\[\]{};':"\\|,.<>\/?\-=]+/.test(e.target.value)){
                waitListSlotValid = 'Value can only include numbers.'
            } else {
                waitListSlotValid = ''
            }
            this.updateState({ [e.target.name]: e.target.value, waitListSlotValid: waitListSlotValid });
        } else {
            this.updateState({ [e.target.name]: e.target.value });
        }
    }

    handleChangenAccessibility = accessibility => {
        this.updateState({
            accessibility: [],
            accessibility: accessibility
        })
    };

    //Accessibility Master Call
    accessibilityOption = () => {
        var options = []
        this.state.accessibility.forEach(item => {
            options.push({ value: item._id, label: item.name })
        });
        return options
    }

    //Accessibility Master Call
    amenitiesOption = () => {
        var options = []
        this.state.amenity.forEach(item => {
            options.push({ value: item._id, label: item.name })
        });
        return options
    }


    handleEditorChange = (editorState, field) => {
        this.updateState({ [field]: editorState });
    }

    Selectvenue = (e) => {
        const { name, value } = e.target;
        this.updateState({
            [name]: { value: value, label: name },
            selectedVenue: value === '' ? '' : { value: value, label: name }
        })
    }

    StateSelectvenue = (e) => {
        const { name, value } = e.target;
        this.updateState({
            [name]: { value: value, label: name },
            state: { value: value, label: name }
        })
    }
    CitySelectvenue = (e) => {
        const { name, value } = e.target;
        this.updateState({
            [name]: { value: value, label: name },
            city: { value: value, label: name }
        })
    }


    handleCheck = (e) => {
        const { name, checked } = e.target;
        this.updateState({ [name]: checked })
    }

    getContent = (field) => {
        const value = field ? convertToRaw(field.getCurrentContent()) : ''
        return draftToHtml(value);
    }

    // Submit Location Form
    SubmitLocation = (e) => {
        e.preventDefault();
        if (this.validator.allValid() && this.state.waitListSlotValid === '') {
            // Conflict check - only for edit mode
            if (this.props.locationEditId && this.props.recordConflict) {
                this.setState({ showConflictModal: true });
                return;
            }

            this.setState({ loaderFlag: true })
            var accessibilityData = this.state && this.state.selectedAccessibility ?.map(e => e.value)
            var amenityData = this.state && this.state.selectedAmenity ?.map(e => e.value)
            // OPhours
            const Opmarkup = this.getContent(this.state.Ophours)

            // AvbusRoutes
            const Avmarkup = this.getContent(this.state.Avbusroutes)

            // Location description
            const locmarkup = this.getContent(this.state.LocDesc)
            const offermarkup = this.getContent(this.state.dailyOffer)
            // Accessibility description
            const accDescmarkup = this.getContent(this.state.acessDesc)
            // Amenities & Features description
            const amenitiesFeaturesMarkup = this.getContent(this.state.amenitiesFeatures)

            let locationData = {
                eventiveId:this.state.eventiveId,
                name: this.state.locationname,
                street: this.state.street,
                city: this.state.city.value,
                state: this.state.state.value,
                zip: this.state.zip,
                operatingHrs: Opmarkup,
                avaliableBusRoutes: Avmarkup,
                venueType: this.state.selectedVenue.value,
                description: locmarkup,
                eventive_description: convertToRaw(this.state.LocDesc.getCurrentContent()).blocks.map(item => item.text).join(''),
                accessibility: accessibilityData,
                accessibilityDescription: accDescmarkup,
                latitude: this.state.latitude,
                longitude: this.state.longitude,
                google_map_link: this.state.google_map_link,
                satellite_screen_link: this.state.satellite_screen_link,
                amenity: amenityData,
                amenitiesFeatures: amenitiesFeaturesMarkup,
                daily_offerings: offermarkup,
                logo: this.state.logo,
                hostName: this.state.hostName,
                images:this.state.images,
                hideFromSchedule: this.state.hide_from_schedule,
                maxWaitListSlots:this.state.maxWaitListSlots || 0,
                expectedUpdatedAt: this.state.editStartVersion || undefined,
            }

            if (this.state.locationId) locationData.locationId = this.state.locationId
            this.apiserve.sendevent(this.state.locationId ? "location|edit" : "location|create", locationData);    
        }
        else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    closeConflictModal = () => {
        this.setState({ showConflictModal: false });
    };

    // cancle click
    cancelFn = () => {
        this.setState({
            discardPopup: true
        })
    }

    closeAdminUser = () => {
        this.setState({
            discardPopup: false,
        });
    }

    discardPopupYes = () => {
        this.props.history.push("/locations");
    }

    clearData = () => {
        this.setState({
            city: "",
            zip: "",
            state: "",
            locationname: "",
            street: "",
            operatingHrs: "",
            avaliableBusRoutes: "",
            description: "",
            // isConncession : false,
            // accessibilityDescription:""
            latitude: "",
            longitude: "",
            google_map_link: "",
            satellite_screen_link: "",
            daily_offerings: '',
            logo: {
                _id: '',
                inSite: '',
            },
            hostName: '',
            maxWaitListSlots:0,
        })
    }


    closeAdminUser = () => this.setState({ deleteImagePopup: false,discardPopup:false });


    handleImageSponsorLogo(e) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({
                file: file,
            }, () => {
                this.uploadSponsorLogo.value = ''
                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 2048) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 2 MB'
                    })
                    return false;
                }
                if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
                    setTimeout(() => {
                        this.imageUploadSponsorLogo(file,event.target.result);
                    }, 1000)
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                    })
                }
            })
        }
    }

    imageUploadSponsorLogo = (file,img) => {
        this.setState({ imagePreloader: true })
        var fileSet = commonImage(file,false,'',img, '',STORAGE_PATHS.LOCATIONS.LOGO)
        fileSet.then((value) => {
                this.setState({
                    logo: {
                        inSite: value,
                    },
                    imagePreloader: false
                })
            })
    }

    deleteLogo() {
        this.setState({
            deleteImagePopup: true,
            LogoDetails: true,
        })
    }
    onDeleteImagePopup = e => {
        if (this.state.LogoDetails) {
            this.updateState({
                logo: {
                    inSite: ''
                }
            })
        }
        if (this.state.images.length) {
            this.state.images.forEach(image => {
                if (image._id === this.state.deleteImageId) {
                    image.inSite = ''
                }
            });
        }
        this.setState({ deleteImagePopup: false });
    };

    errorMsgPopup = () => {
        this.setState({
            errorPopup: false
        })
    }

    handleImage(e, id) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({
                file: file,
            }, () => {
                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 2048) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 2 MB'
                    })
                    return false;
                }
                if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
                    setTimeout(() => {
                        this.imageUploadOne(file, id,false,event.target.result);
                    }, 0)
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                    })
                }
            })
        }
    }

    imageUploadOne = (file, id,IsFPGUpload=true,img) => {
        const imagePreloaderId = `imagePreloader_${id}`
        const newState = { ...this.state }
        newState[imagePreloaderId] = true
        this.setState(newState)
        var fileSet = commonImage(file,IsFPGUpload, this.apiserve.formaT,img, '',STORAGE_PATHS.LOCATIONS.IMAGE)
        fileSet.then((value) => {
                this.state.images.forEach(image => {
                    const imagePreloaderId = `imagePreloader_${id}`
                    const newState = { ...this.state }
                    newState[imagePreloaderId] = false
                    this.setState(newState)
                    if (image._id === id) {
                        image.inSite = value
                        image.link=''
                    }

                });
                this.updateState({})
            });
    };

    deleteImage(id) {
        this.setState({
            deleteImagePopup: true,
            deleteImageId: id
        })
    }

    insideOnchange = (e, id) => {
        const { name, value } = e.target
        this.state.images.forEach(inside => {
            if (inside._id === id) {
                inside.link = value
                inside.inSite=''
                this.updateState({})
                this.validator.showMessageFor('image or link')
            } 
        });
        this.forceUpdate()
    }
    validLink = (link) => {
        let regex = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
        if(regex.test(link)){
            return link
        } else {
            return '/images/image-placeholder.png'
        }
    }
    imageOnError = (event) => {
        event.currentTarget.src = `/images/image-placeholder.png`;
    };

    handleKeySlider = (e) => {
        if (e.keyCode === 9) { // Check if the pressed key is Tab (key code 9)
            e.preventDefault(); // Prevent the default tab focus behavior
        }
    }

    render() {
        var updateAt = new Date(this.state.lastUpdatedAt)
        var hour = moment(updateAt).format('h')
        var minutes = moment(updateAt).format('mm')
        var state = moment(updateAt).format('A')
        var settings = {
            customPaging: function (i) {
                return (
                    <a>{i + 1}</a>
                );
            },
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };
        return (
            <div className="right_side_wrapper ">
                <ul className="fpg_admin_tab disp_flex">
                    <li className="active">
                        <p className="uppercase text_center">
                            <div>LOCATION DETAILS</div>
                            <span onClick={() => this.props.history.push('/locations')}><PlusIcon /></span>
                        </p>
                    </li>
                </ul>
                <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                    <Link className="back_link" to="/locations">
                        <svg width="5" height="10" viewBox="0 0 5 10" fill="none"> <path d="M5 0L0 5L5 10V0Z" fill="black" /> </svg>
                        Back to List
                    </Link>
                    <p className="update_date">
                        Last Update: {hour}:{minutes} {state} -  {moment(this.state.lastUpdatedAt).format('MM/DD/YY')} by {(this.state.lastUpdatedBy && this.state.lastUpdatedBy.fname) + ' ' + (this.state.lastUpdatedBy && this.state.lastUpdatedBy.lname)}
                    </p>
                </div>
                <RecordPresenceBanner activeViewers={this.props.recordViewers} conflict={this.props.recordConflict} />
                <div className="fpg_tabcontent pl_15 about_sundance">
                    <form onSubmit={this.SubmitLocation}>
                        <div className="d_flex">
                            <div className="location_col">
                                <div className="field_row horizontal_field">
                                    <TextField
                                        type="text"
                                        label="Eventive ID"
                                        name="eventiveId"
                                        value={this.state.eventiveId}
                                        disable={true}
                                    />
                                </div>
                                <div className="field_row horizontal_field">
                                    <div className="field_row_inner">
                                        <label>Hide From Schedule</label>
                                        <div className="relative mt_10">
                                            <div className="checkbox_field_row">
                                                <div className="checkBox">
                                                    <input 
                                                        type="checkbox"
                                                        id="hide_from_schedule" 
                                                        name="hide_from_schedule" 
                                                        checked={this.state.hide_from_schedule}
                                                        onChange={(e) => this.handleCheck(e)} />
                                                    <label for="hide_from_schedule" style={{width:"auto"}}></label>
                                                </div>
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                                <div className="field_row horizontal_field">
                                    <TextField
                                        type="text"
                                        label="Location Name"
                                        name="locationname"
                                        value={this.state.locationname}
                                        onChange={this.onInputChange}
                                        fpgerror={this.validator.message('Location Name', this.state.locationname, 'Locname|required')}
                                    />
                                </div>
                                <div className="field_row horizontal_field">
                                    <TextField
                                        type="text"
                                        label="Street Address"
                                        name="street"
                                        value={this.state.street}
                                        onChange={this.onInputChange}
                                        fpgerror={this.validator.message('Address', this.state.street, 'Locaddress|required')}
                                    />
                                </div>
                                <div className="field_row horizontal_field relative">
                                    <DropdownMaster
                                        name="text"
                                        label="City"
                                        isdefaultDisable={true}
                                        options={this.state.cityoption}
                                        value={this.state.city ? this.state.city.value : 'Select From Below'}
                                        onChange={(e) => this.CitySelectvenue(e)}
                                        fpgerror={this.validator.message('City', this.state.city && this.state.city.value, 'City|required')}
                                    />
                                </div>
                                <div className="field_row horizontal_field relative">
                                    <DropdownMaster
                                        name="state"
                                        label="State"
                                        isdefaultDisable={true}
                                        options={this.state.stateoption}
                                        value={this.state.state ? this.state.state.value : 'Select From Below'}
                                        onChange={(e) => this.StateSelectvenue(e)}
                                        fpgerror={this.validator.message('State', this.state.state && this.state.state.value, 'State|required')}
                                    />
                                </div>
                                <div className="field_row horizontal_field">
                                    <TextField
                                        type="text"
                                        label="Zip Code"
                                        name="zip"
                                        value={this.state.zip}
                                        onChange={this.onInputChange}
                                        fpgerror={this.validator.message('Zip Code', this.state.zip, 'Zip|required')}
                                    />
                                </div>
                                <div className="field_row horizontal_field">
                                    <TextField
                                        type="text"
                                        label="Latitude"
                                        name="latitude"
                                        value={this.state.latitude}
                                        onChange={this.onInputChange}
                                    />
                                </div>
                                <div className="field_row horizontal_field">
                                    <TextField
                                        type="text"
                                        label="Longitude"
                                        name="longitude"
                                        value={this.state.longitude}
                                        onChange={this.onInputChange}
                                    />
                                </div>
                                <div className="field_row horizontal_field">
                                    <TextField
                                        type="text"
                                        label="Google Maps Link"
                                        name="google_map_link"
                                        value={this.state.google_map_link}
                                        onChange={this.onInputChange}
                                    />
                                </div>
                                <div className="field_row horizontal_field">
                                    <TextField
                                        type="text"
                                        label="Satellite Screen Link"
                                        name="satellite_screen_link"
                                        value={this.state.satellite_screen_link}
                                        onChange={this.onInputChange}
                                    />
                                </div>
                                <div className="field_row horizontal_field">
                                    <div className="field_row_inner">
                                        <label>Operating Hours</label>
                                        <div className="field_input relative editor_wrapper">
                                            <div className="bg_white">
                                                <TextEditor
                                                    name="Ophours"
                                                    editorState={this.state.Ophours}
                                                    value={this.state.Ophours}
                                                    onEditorStateChange={(e) => this.handleEditorChange(e, 'Ophours')}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="field_row horizontal_field">
                                    <div className="field_row_inner">
                                        <label>Transportation</label>
                                        <div className="field_input relative editor_wrapper">
                                            <div className="bg_white">
                                                <TextEditor
                                                    name="Avbusroutes"
                                                    value={this.state.Avbusroutes}
                                                    editorState={this.state.Avbusroutes}
                                                    onEditorStateChange={(e) => this.handleEditorChange(e, 'Avbusroutes')}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="field_row horizontal_field relative">
                                    <DropdownMaster
                                        name="venuetype"
                                        label="Venue Type"
                                        isdefaultDisable={true}
                                        options={this.state.venueType}
                                        value={this.state.selectedVenue ? this.state.selectedVenue.value : 'Select From Below'}
                                        onChange={(e) => this.Selectvenue(e)}
                                        fpgerror={this.validator.message('Venue Type', this.state.selectedVenue, 'VenueType|required')}
                                    />
                                </div>
                                <div className="field_row horizontal_field">
                                    <div className="field_row_inner">
                                        <label>Daily Offerings</label>
                                        <div className="field_input relative editor_wrapper">
                                            <div className="bg_white">
                                                <TextEditor
                                                    editorState={this.state.dailyOffer}
                                                    name="dailyOffer"
                                                    value={this.state.dailyOffer}
                                                    onEditorStateChange={(e) => this.handleEditorChange(e, 'dailyOffer')}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="location_col">
                                <div className="field_row horizontal_field">
                                    <div className="field_row_inner">
                                        <label>Location Description</label>
                                        <div className="field_input relative editor_wrapper">
                                            <div className="bg_white">
                                                <TextEditor
                                                    editorState={this.state.LocDesc}
                                                    name="LocDesc"
                                                    value={this.state.LocDesc}
                                                    onEditorStateChange={(e) => this.handleEditorChange(e, 'LocDesc')}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="field_row horizontal_field">
                                    <div className="field_row_inner">
                                        <label>Amenities & Features</label>
                                        <div className="field_input relative editor_wrapper">
                                            <div className="bg_white">
                                                <TextEditor
                                                    editorState={this.state.amenitiesFeatures}
                                                    name="amenitiesFeatures"
                                                    value={this.state.amenitiesFeatures}
                                                    onEditorStateChange={(e) => this.handleEditorChange(e, 'amenitiesFeatures')}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="field_row horizontal_field relative zindex2">
                                    <div className="field_row_inner">
                                        <label>Amenities</label>

                                        <div className="select_field ">
                                            <Select
                                                isMulti
                                                onChange={this.AmenityChange}
                                                options={this.amenitiesOption()}
                                                value={this.state.selectedAmenity}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="field_row horizontal_field">
                                    <div className="field_row_inner">
                                        <label>Accessibility</label>
                                        <div className="field_input relative editor_wrapper">
                                            <div className="bg_white">
                                                <TextEditor
                                                    editorState={this.state.acessDesc}
                                                    name="acessDesc"
                                                    value={this.state.acessDesc}
                                                    onEditorStateChange={(e) => this.handleEditorChange(e, 'acessDesc')}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="field_row horizontal_field relative zindex3">
                                    <div className="field_row_inner">
                                        <label>Accessibility Accommodations</label>

                                        <div className="select_field ">
                                            <Select
                                                isMulti
                                                onChange={this.AccessibilityChange}
                                                options={this.accessibilityOption()}
                                                value={this.state.selectedAccessibility}
                                            />

                                            {/* <span className="error">{this.validator.message('Accessibility', this.state.selectedAccessibility, 'required')}</span> */}
                                        </div>
                                    </div>
                                </div>

                                <div className="field_row horizontal_field">
                                    <div className="field_row_inner">
                                        <label>Logo</label>
                                        <div className="create_location_title_content_img_box loader-main">
                                            {this.state.imagePreloader ?
                                                <Loader />
                                                :
                                                <img style={{height:'100%'}}
                                                    src={this.state.logo ?.inSite
                                                        ? this.apiserve.imageUrl + this.state.logo ?.inSite
                                                            : '/images/image-placeholder2.png'} alt="image"
                                                />
                                            }
                                            <div className={`input_file ${this.state.logo ?.inSite ? 'active' : ''}`}>
                                                <input id="myInput"
                                                    type="file"
                                                    ref={(ref) => this.uploadSponsorLogo = ref}
                                                    style={{ display: 'none' }}
                                                    onChange={this.handleImageSponsorLogo.bind(this)}
                                                    accept=".png, .jpg, .jpeg"
                                                />
                                                <span onClick={() => { this.uploadSponsorLogo.click() }}><AddFileIcon /></span>
                                            </div>
                                            {this.state.logo ?.inSite &&
                                                <span className="remove_file pointer" onClick={() => this.deleteLogo()}><DeletefileIcon /></span>
                                                    }
                                        </div>
                                    </div>
                                </div>
                                <div className="field_row horizontal_field add_margin">
                                    <TextField
                                        type="text"
                                        label="Host Name"
                                        name="hostName"
                                        value={this.state.hostName}
                                        onChange={this.onInputChange}
                                    />
                                </div>
                                <div className="field_row horizontal_field add_margin">
                                    <TextField
                                        type="text"
                                        pattern="[0-9]*"
                                        label="Maximum Waitlist Slots"
                                        name="maxWaitListSlots"
                                        value={this.state.maxWaitListSlots}
                                        onChange={this.onInputChange}
                                    />
                                    <span className='error srv-validation-message' style={{ color: 'red' }}>{this.state.waitListSlotValid}</span>
                                </div>
                                <div className="field_row horizontal_field input_img">
                                    <div className=''>
                                    <label></label>
                                    <Slider {...settings} >
                                        {this.state.images &&
                                        this.state.images.map((item, index) => {
                                            const imagePreloaderState = `imagePreloader_${item._id}`
                                            return (
                                                <div>
                                                    <div className="media_image mb_0 absolute_loader" style={{width:'400px'}}>
                                                        {this.state[imagePreloaderState] ?
                                                            <Loader />
                                                            :
                                                            <img src={item.inSite ? this.apiserve.imageUrl + item.inSite : item.link ? this.validLink(item.link) : '/images/image-placeholder.png'} alt="image" onError={(e) => this.imageOnError(e)}/>
                                                        }
                                                        <span className="upload_message">Upload PNG/JPEG of max size of 2MB</span>
                                                        <UploadForm item={item} handleImage={(e) => this.handleImage(e, item._id)} deleteImage={() => this.deleteImage(item._id)} iconDelete={true} />
                                                    </div>
                                                    <div className="field_row">
                                                        <div className="field_input relative">
                                                            <input
                                                                type="text"
                                                                placeholder="https://cloudfront.aws.com/sdf2345"
                                                                name='link'
                                                                id={item._id}
                                                                value={item.link}
                                                                onChange={(e) => this.insideOnchange(e, item._id)}
                                                                onKeyDown={(e) => this.handleKeySlider(e)}
                                                            />
                                                            <span className="copy_box pointer_auto">
                                                                <CopyIcon />
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {index === 0 ?
                                                        <span style={{ color: 'red' }}>{this.validator.message('image or link', item.link || item.inSite, 'required|urlValidation')}</span>
                                                        : ''
                                                    }
                                                </div>
                                            )
                                        })}
                                    </Slider>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div className="text_center field_row w_100 buttons_outer mb_0">
                            <button className="grayBTN" type="button" onClick={() => this.cancelFn()} > Cancel </button>
                            <button className={`${this.state.loaderFlag || (this.state.locationId ? !this.state.iscreateLocationsEdited : false) ? '' : "active"}`} type="button" onClick={this.SubmitLocation}  disabled={this.state.loaderFlag || (this.state.locationId ? !this.state.iscreateLocationsEdited : false)}> Submit </button>
                        </div>
                    </form>
                </div>



                {this.state.discardPopup ? (
                    <PopUpCustomAll
                        HeaderName="Discard Changes?"
                        insideDetails="Leaving this page without saving will discard all changes"
                        insideData="Do you want to proceed?"
                        popupState={this.closeAdminUser}
                        yesPopUp={this.discardPopupYes}
                    />
                ) : (
                        ""
                    )}

                {this.state.errorPopup ?
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.errorMsgPopup}
                    />
                    : ''
                }

                {/* Loader */}
                {this.state.loaderFlag ? (
                    <Loader />
                ) : (
                        ""
                    )}

                {this.state.deleteImagePopup ? (
                    <PopUpCustomAll
                        HeaderName="Delete Image?"
                        insideDetails="Are You Sure ?"
                        insideData="You want to delete this image"
                        popupState={() => this.closeAdminUser()}
                        yesPopUp={() => this.onDeleteImagePopup()}
                    />
                ) : (
                        ""
                    )}

                <ConflictSaveModal
                    isVisible={this.state.showConflictModal}
                    conflict={this.props.recordConflict}
                    onClose={this.closeConflictModal}
                />

            </div>
        )
    }



    componentDidUpdate(prevProps) {
        if (prevProps.allInitial !== this.props.allInitial) {
            if (this.props.allInitial && this.props.allInitial.location) {
                this.setState({
                    accessibility: this.props.allInitial.location.accessibility,
                    venueType: this.props.allInitial.location.venueType,
                    amenity: this.props.allInitial.location.amenity,
                    cityoption: this.props.allInitial.location.city
                })
            }
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateLocations)